<template>
  <div class="container" @scroll="handleScroll">
    <Header @navigate="scrollToSection" />

    <div>
      <div class="home">
        <img src="@/assets/home-img.png" alt="" />
        <div class="erweima" @click="goTargetAPKBaidu">
          <div style="border-right: 1px #000 solid">
            <img
              src="../../assets/telegram 2.png"
              style="width: 35px; height: 35px; margin: 0 10px"
              alt=""
            />
            <!-- 百度地图下载地址 -->
            <img
              src="../../assets/Frame 1321315178.png"
              style="width: 80px; height: 37px; margin-right: 10px"
              alt=""
            />
          </div>

          <div class="erweima_down">
            <div class="erweima_img">
              <img :src="erweimaURLBaidu" alt="" />
              <div class="erweima_hover">
                <img v-if="erweimaURLBaidu" :src="erweimaURLBaidu" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div
          class="erweima"
          style="left: calc(50% + 30px)"
          @click="goTargetAPKGoogle"
        >
          <!-- 谷歌地图下载地址 -->
          <div style="border-right: 1px #000 solid">
            <img
              src="../../assets/telegram 2.png"
              style="width: 35px; height: 35px; margin: 0 10px"
              alt=""
            />
            <img
              src="../../assets/Frame 1321315179.png"
              style="width: 80px; height: 37px; margin-right: 10px"
              alt=""
            />
          </div>

          <div class="erweima_down" style="top: calc(64% - 18px)">
            <div class="erweima_img">
              <img :src="erweimaURLGoogle" alt="" />
              <div class="erweima_hover">
                <img v-if="erweimaURLGoogle" :src="erweimaURLGoogle" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="erweima_tele" @click="goTarget">
          <img src="../../assets/telegram 1.png" alt="" />
          <div style="padding: 0 5px">
            <p>{{ $t("立即加入社区") }}</p>
            <h3>{{ t("获取最新资讯") }}</h3>
          </div>
        </div>
      </div>

      <div class="home_page">
        <div class="header_page_img">
          <img src="../../assets/homepage-img.png" alt="" />
        </div>

        <div class="erweima">
          <div
            class="erweima_tele2"
            @click="goTargetAPKBaidu"
            style="margin-right: 5px"
          >
            <!-- 百度地图 -->
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                border-bottom: 1px #3f3e3e solid;
              "
            >
              <img
                src="../../assets/Frame 1321315180.png"
                style="width: 81px; height: 34px; margin: 8px 0"
                alt=""
              />
              <img
                src="../../assets/telegram 3.png"
                style="width: 41px; height: 28px"
                alt=""
              />
            </div>

            <div class="erweima_img">
              <img :src="erweimaURLBaidu" alt="" />
            </div>
          </div>
          <div
            class="erweima_tele2"
            @click="goTargetAPKGoogle"
            style="margin-right: 5px"
          >
            <!-- 谷歌地图 -->
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                border-bottom: 1px #3f3e3e solid;
              "
            >
              <img
                src="../../assets/Frame 1321315181.png"
                style="width: 81px; height: 34px; margin: 8px 0"
                alt=""
              />
              <img
                src="../../assets/telegram 3.png"
                style="width: 41px; height: 28px"
                alt=""
              />
            </div>

            <div class="erweima_img">
              <img :src="erweimaURLBaidu" alt="" />
            </div>
          </div>
          <!-- <div style="display: flex">
            <div
              class="erweima_tele2"
              @click="goTargetAPK"
              style="margin-right: 5px"
            >
             
             
            </div>
            <div class="erweima_tele" @click="goTarget">
              <img src="../../assets/telegram 1.png" alt="" />
              <div style="padding: 0 5px">
                <p>{{ $t("立即加入社区") }}</p>
                <h3>{{ t("获取最新资讯") }}</h3>
              </div>
            </div>
          </div> -->
          <!--  -->
        </div>
      </div>
    </div>

    <div ref="aboutSection">
      <About />
    </div>
    <div ref="roleSection">
      <Role />
    </div>
    <div ref="nftSection">
      <NFT />
    </div>
    <div ref="nftNotSection">
      <NFTNot />
    </div>
    <div ref="cpleSection">
      <CPLE />
    </div>
    <!-- <div ref="buySection">
      <Buy />
    </div> -->

    <Footer />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

const { t, locale } = useI18n();

import Header from "@/components/Header";
import Notice from "@/views/Notice";
import About from "@/views/About";
import Role from "@/views/Role";
import NFT from "@/views/NFT";
import NFTNot from "@/views/NFT/not.vue";
import CPLE from "@/views/CPLE";
import Buy from "@/views/Buy";
import Footer from "@/components/Footer";

const aboutSection = ref(null);
const roleSection = ref(null);
const nftSection = ref(null);
const nftNotSection = ref(null);
const cpleSection = ref(null);
const buySection = ref(null);
const erweimaURLBaidu = ref("");
const erweimaURLGoogle = ref("");
const baiduAPKURL = ref("");
const googleAPKURL = ref("");

axios
  .get("https://sfcmgr.bnsfc.com/api/app/user/version/getDownloadUrl")
  .then((response) => {
    console.log(response.data);
    erweimaURLBaidu.value = response.data.data.androidBaidu.qrCode;
    erweimaURLGoogle.value = response.data.data.androidGoogle.qrCode;
    baiduAPKURL.value = response.data.data.androidBaidu.url;
    googleAPKURL.value = response.data.data.androidGoogle.url;
  })
  .catch((error) => {
    console.error("There was an error!", error);
  });

const scrollToSection = (section) => {
  if (section === t("公告")) {
    // ✅ 公告跳新页面
    window.open("/notice", "_blank"); // 或者直接跳转：router.push("/notice")
    return;
  }

  switch (section) {
    case t("关于"):
      aboutSection.value.scrollIntoView({ behavior: "smooth" });
      break;
    case t("角色"):
      roleSection.value.scrollIntoView({ behavior: "smooth" });
      break;
    case t("NFT"):
      nftSection.value.scrollIntoView({ behavior: "smooth" });
      break;
    case t("币安顺风车"):
      cpleSection.value.scrollIntoView({ behavior: "smooth" });
      break;
    // case t("购买"):
    //   buySection.value.scrollIntoView({ behavior: "smooth" });
    //   break;
  }
};

const goTarget = () => {
  const externalLink = "https://t.me/bnsfc888";
  window.open(externalLink, "_blank");
};

const isChinese = computed(() => {
  const v = String(locale.value || "").toLowerCase();
  return v === "zh";
});

// ✅ 根据语言动态选择 APK 下载链接
const goTargetAPK = () => {
  const externalLink = isChinese.value
    ? "https://www.bnsfc.com/bnsfc.apk"
    : "https://www.bnsfc.com/bnsfcgmap.apk";
  window.open(externalLink, "_blank");
};

const goTargetAPKBaidu = () => {
  window.open(baiduAPKURL.value, "_blank");
};
const goTargetAPKGoogle = () => {
  window.open(googleAPKURL.value, "_blank");
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  overflow-y: auto; /* 允许垂直滚动 */
}

.home {
  width: 100%;
  height: 100vh;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .erweima {
    width: auto;
    height: 64px;
    position: absolute; /* 保留你原有的绝对定位，不改动 */
    top: calc(50% - 18px);
    left: calc(50% - 228px);
    background: #fff;
    border-radius: 16px; /* 16px圆角生效 */
    display: flex;
    align-items: center;
    cursor: pointer;
    /* 核心渐变边框代码，仅这4行 */
    border: 4px solid transparent;
    background: linear-gradient(#fff, #fff) padding-box,
      linear-gradient(90deg, #00ff80 0%, #f2ff5c 100%) border-box;
    background-clip: padding-box, border-box;
    box-sizing: border-box; /* 防止边框撑大尺寸 */
  }

  .erweima_tele,
  .erweima_hover {
    display: flex;
    align-items: center;
    border-radius: 16px;
    background: #fff;
  }

  .erweima_tele {
    justify-content: space-evenly;
    height: 64px;
    padding: 0 10px;
    cursor: pointer;
    position: absolute;
    top: calc(65% - 40px);
    left: calc(50% + -62px);

    img {
      width: 35px;
      height: 35px;
    }

    p {
      font-size: 12px;
      margin-bottom: 5px;
    }

    h3 {
      font-size: 16px;
    }
  }

  .erweima_down {
    margin-left: 5px;
  }

  .erweima_img {
    width: 55px;
    height: 55px;
    justify-content: center;
    position: relative;
    margin-right: 10px;

    .erweima_hover {
      width: 156px;
      height: 156px;
      justify-content: center;
      display: none !important; /* 默认不展示 */
      position: absolute; /* 可以根据需要调整位置 */
      top: 73px; /* 根据需要调整位置 */
      left: 0; /* 根据需要调整位置 */
      z-index: 10; /* 确保在其他元素之上 */
      opacity: 0; /* 默认透明 */
      transition: opacity 0.3s ease; /* 添加动画效果 */

      img {
        width: 140px;
        height: 140px;
      }
    }

    &:hover .erweima_hover {
      display: flex !important; /* 鼠标移入时显示 */
      opacity: 1; /* 渐显 */
    }
  }
}

@media (max-width: 600px) {
  .home,
  .about,
  .role,
  .nft,
  .nft-not,
  .buy,
  .cple,
  .footer {
    display: none;
  }

  .home_page {
    .header_page_img {
      img {
        width: 100%;
        height: 275px;
      }
    }

    .erweima {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .erweima_tele,
      .erweima_tele2 {
        height: 64px;
        background: #fff;
        border-radius: 16px;

        margin-top: 30px;
        padding: 0 10px;

        img {
          width: 26px;
          height: 26px;
        }

        p {
          font-size: 12px;
          margin-bottom: 5px;
        }

        h3 {
          font-size: 16px;
        }
      }

      .erweima_tele2 {
        width: 162px;
        height: 220px;
        border: 4px solid transparent;
        border: 4px solid transparent;
        border-radius: 24px;
        background: linear-gradient(#000, #000) padding-box,
          linear-gradient(90deg, #00ff80 0%, #f2ff5c 100%) border-box;
        background-clip: padding-box, border-box;
      }

      .erweima_img {
        width: 145px;
        height: 145px;
        margin-top: 8px;
        margin-left: 10px;

        img {
          width: 140px;
          height: 140px;
          border-radius: 14px;
        }
      }
    }
  }

  .container {
    height: 100vh;
    overflow-y: scroll; /* 允许垂直滚动 */
    background: #000000;

    .home_page,
    .about_page,
    .role_page {
      display: block;
    }
  }
}

@media (min-width: 601px) {
  .header_page,
  .home_page,
  .about_page,
  .role_page,
  .cple_page,
  .buy_page,
  .nft-not_page,
  .footer_page {
    display: none; /* 在大屏幕下隐藏 header_page */
  }

  .home,
  .about,
  .role,
  .nft,
  .nft-not {
    display: block; /* 在大屏幕下显示其他组件 */
  }

  .buy,
  .cple,
  .footer {
    display: flex; /* 在大屏幕下显示其他组件 */
  }
}
</style>
